import type { IframeHTMLAttributes } from 'react';

import { useBlobAccessUrl } from '@/hooks/useBlobAccessUrl';

type BlobIframeProps = IframeHTMLAttributes<HTMLIFrameElement> & {
	src: string | null | undefined;
};

export function BlobIframe({ src, ...props }: BlobIframeProps) {
	const accessUrl = useBlobAccessUrl(src);

	if (!accessUrl) return null;
	return <iframe {...props} src={accessUrl} />;
}
